var exports = {
  "root": "x24da60e8--dc4fd8--root",
  "main": "x24da60e8--dc4fd8--main",
  "phone": "x24da60e8--dc4fd8--phone",
  "tablet": "x24da60e8--dc4fd8--tablet",
  "container": "x24da60e8--dc4fd8--container",
};

module.exports = exports;
